// === Easify Box Builder: Enforce Min-2 Quantity (merged) ===
const tagToEnforce = "min-2";
let min2Products = [];

// --- Fetch all Shopify products with min-2 tag ---
fetch("/collections/all/products.json?limit=250")
  .then(res => res.json())
  .then(data => {
    min2Products = (data.products || [])
      .filter(p => {
        const tagLower = tagToEnforce.toLowerCase();
        if (Array.isArray(p.tags)) {
          return p.tags.some(t => String(t).trim().toLowerCase() === tagLower);
        }
        return String(p.tags || "")
          .split(",")
          .map(t => t.trim().toLowerCase())
          .includes(tagLower);
      })
      .map(p => ({ id: p.id, title: (p.title || "").trim() }));
  })
  .catch(err => console.warn("Failed to fetch Shopify products:", err));

// --- Helpers ---
function isMin2ProductName(name) {
  if (!name) return false;
  const n = name.trim();
  return min2Products.some(p => p.title === n);
}
function isMin2ByGid(gidStr) {
  if (!gidStr) return false;
  const m = gidStr.match(/Product\/(\d+)/);
  if (!m) return false;
  const numericId = parseInt(m[1], 10);
  if (isNaN(numericId)) return false;
  return min2Products.some(p => p.id === numericId);
}
function gidNumeric(gidStr) {
  const m = gidStr?.match(/Product\/(\d+)/);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return isNaN(n) ? null : n;
}
function gidShort(gidStr) {
  return gidStr ? String(gidStr).replace("gid://shopify/Product/", "") : null;
}
function titleFromMin2ByGid(gidStr) {
  const id = gidNumeric(gidStr);
  if (!id) return null;
  const hit = min2Products.find(p => p.id === id);
  return hit ? hit.title : null;
}
function setInputTo2AndDispatch(qtyInput) {
  qtyInput.value = 2;
  ["input", "change", "blur"].forEach(evt => qtyInput.dispatchEvent(new Event(evt, { bubbles: true })));
}
function updateMinusLock(qty, minusBtn) {
  if (!minusBtn) return;
  if (qty <= 2) {
    minusBtn.disabled = true;
    minusBtn.dataset.minLocked = "true";
    minusBtn.style.pointerEvents = "none";
    minusBtn.style.opacity = "0.45";
    minusBtn.style.cursor = "not-allowed";
  } else {
    minusBtn.disabled = false;
    minusBtn.dataset.minLocked = "false";
    minusBtn.style.pointerEvents = "";
    minusBtn.style.opacity = "";
    minusBtn.style.cursor = "";
  }
}
function textQty(el) {
  if (!el) return null;
  const v = parseInt((el.textContent || "0").trim(), 10);
  return isNaN(v) ? null : v;
}
function findProductName(container) {
  return (
    container.querySelector(".productSelected-module__name_product_selected__Ah span") ||
    container.querySelector(".productContent-module__product_information_title__em") ||
    container.querySelector(".productContent-module__product_name__text__kU span")
    // Note: do NOT fall back to modal h3 (it's just "Quantity")
  );
}

// --- Core: handle grid inline selector after first add ---
function bumpInlineSelectorTo2(inCardOrRoot) {
  const wrapper = inCardOrRoot.querySelector(".PRODUCT_CARD_QUANTITY_SELECTOR_WRAPPER_TS") ||
                  inCardOrRoot.querySelector(".quantityInput-module__add_quantity_product_wrap__H0");
  if (!wrapper) return false;
  const qtyTextEl = wrapper.querySelector(".quantityInput-module__product_quantity__bZ");
  const minusBtn = wrapper.querySelector(".quantityInput-module__icon_product_quantity__Xv:first-child");
  const plusBtn  = wrapper.querySelector(".quantityInput-module__icon_product_quantity__Xv:last-child");
  const current = textQty(qtyTextEl) ?? 1;
  if (current < 2 && plusBtn) {
    plusBtn.click();
    if (qtyTextEl) qtyTextEl.textContent = "2";
  }
  const now = textQty(qtyTextEl) ?? 2;
  updateMinusLock(now, minusBtn);
  return true;
}

// --- Add interception (safe, waits for React-controlled input to settle) ---
function setupAddInterception() {
  document.addEventListener("click", async (e) => {
    const target = e.target.closest(
      ".PRODUCT_CARD_ATC_BUTTON_TS, .QUICK_VIEW_ADD_TO_BOX_BUTTON_TS, .addToBoxButton-module__button_atc__zo button, .modalDetailProduct-module__product_modal_btn_atc__Si"
    );
    if (!target) return;

    // Find the modal (if present) or the product card container
    const modal = target.closest(".modalDetailProduct-module__product_content_action__fJ, .modalDetailProduct-module__product_modal_quantity__Wa");
    const container = target.closest(".productContent-module__card_product__Hh") || modal || document;

    // Prefer GID-based min-2 detection if an input exists; else fall back to product name (scoped only)
    const qtyInput = container.querySelector('input[name="quantity"]');
    const nameEl = findProductName(container);
    const productName = nameEl ? nameEl.textContent.trim() : "";
    const shouldEnforce = qtyInput ? isMin2ByGid(qtyInput.id) : isMin2ProductName(productName);
    if (!shouldEnforce) return;

    if (!qtyInput) {
      // Not a modal stepper — allow normal flow but ensure inline selector bumped asynchronously
      setTimeout(() => bumpInlineSelectorTo2(target.closest(".productContent-module__card_product__Hh") || document), 0);
      return;
    }

    // If modal qty already >= 2, allow the original click to proceed
    let now = parseInt(qtyInput.value || "0", 10);
    if (!isNaN(now) && now >= 2) return;

    // Otherwise enforce min-2 before add
    e.stopImmediatePropagation();
    e.preventDefault();

    // capture identifying info (optional debug/use)
    const gid = qtyInput.id || null;
    const name = productName || null;

    // Optionally store pending token
    window.__easify_min2_pending = { gid, name, ts: Date.now() };

    const plusBtn = container.querySelector(".quantityStepper-module__button_increment__6R");
    if (plusBtn) {
      plusBtn.click();

      const deadline = Date.now() + 900;
      while (Date.now() < deadline) {
        await new Promise(r => setTimeout(r, 40));
        const v = parseInt(qtyInput.value || "0", 10);
        if (!isNaN(v) && v >= 2) break;
      }

      // re-dispatch original Add click
      setTimeout(() => {
        target.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, composed: true }));
      }, 60);

      return;
    }

    // fallback: no plus button, set value and dispatch events then re-click
    qtyInput.value = "2";
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    setTimeout(() => {
      target.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, composed: true }));
    }, 120);
  }, true);
}

// --- Enforce modal quantityStepper by product ID ---
function enforceModalStepperById() {
  document.querySelectorAll(".modalDetailProduct-module__product_modal_quantity__Wa").forEach((modalQty) => {
    const qtyInput = modalQty.querySelector('input[name="quantity"]');
    const minusBtn = modalQty.querySelector(".quantityStepper-module__button_decrement__QI");
    const plusBtn  = modalQty.querySelector(".quantityStepper-module__button_increment__6R");
    if (!qtyInput) return;
    if (!isMin2ByGid(qtyInput.id)) return;
    let current = parseInt(qtyInput.value || "1", 10);
    if (isNaN(current) || current < 2) { setInputTo2AndDispatch(qtyInput); current = 2; }
    updateMinusLock(current, minusBtn);
    if (!qtyInput._min2Guard) {
      qtyInput.addEventListener("input", () => {
        let v = parseInt(qtyInput.value || "0", 10);
        if (isNaN(v) || v < 2) { setInputTo2AndDispatch(qtyInput); v = 2; }
        updateMinusLock(v, minusBtn);
      });
      qtyInput._min2Guard = true;
    }
    if (plusBtn && !plusBtn._min2Guard) {
      plusBtn.addEventListener("click", () => {
        const v = parseInt(qtyInput.value || "0", 10);
        updateMinusLock(v, minusBtn);
      });
      plusBtn._min2Guard = true;
    }
  });
}

// --- Background enforcement to keep UI consistent ---
function enforceEverywhere() {
  document.querySelectorAll(".productSelected-module__product_selected_content__YS").forEach((sel) => {
    const nameEl = sel.querySelector(".productSelected-module__name_product_selected__Ah span");
    const isMin2 = isMin2ProductName(nameEl ? nameEl.textContent.trim() : "");
    if (!isMin2) return;
    const wrapper = sel.querySelector(".quantityInput-module__add_quantity_product_wrap__H0");
    if (!wrapper) return;
    const qtyTextEl = wrapper.querySelector(".quantityInput-module__product_quantity__bZ");
    const minusBtn = wrapper.querySelector(".quantityInput-module__icon_product_quantity__Xv:first-child");
    const plusBtn  = wrapper.querySelector(".quantityInput-module__icon_product_quantity__Xv:last-child");
    const current = textQty(qtyTextEl) ?? 1;
    if (current < 2) {
      if (plusBtn) plusBtn.click();
      if (qtyTextEl) qtyTextEl.textContent = "2";
    }
    const now = textQty(qtyTextEl) ?? 2;
    updateMinusLock(now, minusBtn);
  });
  enforceModalStepperById();
  
}

// --- Observe DOM changes and run enforcement ---
const observer = new MutationObserver(() => enforceEverywhere());
observer.observe(document.body, { childList: true, subtree: true });

// --- Periodic backup enforcement + interception ---
setupAddInterception();
setInterval(enforceEverywhere, 800);

// --- Debug controls ---
window.__easify_min2 = {
  stop() { observer.disconnect(); console.log("[min-2] Observer stopped"); },
  start() { observer.observe(document.body, { childList: true, subtree: true }); console.log("[min-2] Observer started"); }
};

// --- Footer totals via data attribute (no extra elements) ---
(function footerTotalsAttr() {
  const fmt = n => n.toFixed(2).replace(".", ",");
  function updateOne(content) {
    const wrapper  = content.querySelector(".productSelected-module__price_product_wrapper__i6");
    const qtyEl    = content.querySelector(".quantityInput-module__product_quantity__bZ");
    const priceRow = content.querySelector(".productSelected-module__product_price_qty__AV");
    const unitSpan = priceRow ? priceRow.querySelector("span") : null;
    if (!wrapper || !qtyEl || !priceRow || !unitSpan) return;
    if (!content.dataset.basePrice) {
      const raw  = (unitSpan.textContent || "").trim();
      const base = parseFloat(raw.replace(/[^\d,.-]/g, "").replace(",", ".")) || 0;
      const sym  = (raw.match(/^[^\d-]+/) || ["€"])[0].trim();
      const suf  = (raw.match(/[A-Za-z]{3,}$/) || ["EUR"])[0].trim();
      content.dataset.basePrice = String(base);
      content.dataset.currencySymbol = sym;
      content.dataset.currencySuffix = suf;
    }
    const base = parseFloat(content.dataset.basePrice || "0");
    const qty  = parseInt((qtyEl.textContent || "1").trim(), 10);
    if (!(base > 0) || !(qty > 0)) return;
    const sym = content.dataset.currencySymbol || "€";
    const suf = content.dataset.currencySuffix || "EUR";
    const totalText = `${sym}${fmt(base * qty)} ${suf}`;
    priceRow.setAttribute("data-line-total", totalText);
  }
  function bindOne(content) {
    if (content._copilotTotalsBound) return;
    content._copilotTotalsBound = true;
    const wrapper = content.querySelector(".productSelected-module__price_product_wrapper__i6");
    const qtyEl   = content.querySelector(".quantityInput-module__product_quantity__bZ");
    if (!wrapper || !qtyEl) return;
    const refresh = () => requestAnimationFrame(() => updateOne(content));
    refresh();
    const minusBtn = wrapper.querySelector(".quantityInput-module__icon_product_quantity__Xv:first-child");
    const plusBtn  = wrapper.querySelector(".quantityInput-module__icon_product_quantity__Xv:last-child");
    if (minusBtn) minusBtn.addEventListener("click", refresh);
    if (plusBtn)  plusBtn.addEventListener("click", refresh);
    if (!qtyEl._copilotObs) {
      const obs = new MutationObserver(refresh);
      obs.observe(qtyEl, { characterData: true, childList: true, subtree: true });
      qtyEl._copilotObs = obs;
    }
  }
  function bindAll() { document.querySelectorAll(".productSelected-module__product_selected_content__YS").forEach(bindOne); }
  bindAll();
  setInterval(() => { bindAll(); document.querySelectorAll(".productSelected-module__product_selected_content__YS").forEach(updateOne); }, 10);
})();

// --- Modal -> footer precise reconcile (treat modal qty as delta to add, capture preQty early) ---
(function modalToFooterPrecise() {
  function userClick(el) { if (!el) return; el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, composed: true })); }
  function readQty(el) { if (!el) return 0; if (el.tagName === 'INPUT') return parseInt(el.value || '0', 10) || 0; return parseInt((el.textContent || '0').trim(), 10) || 0; }
  function normalize(s){ return s ? s.toString().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim().toLowerCase() : ''; }

  function findFooter(gid, name) {
    const items = Array.from(document.querySelectorAll('.productSelected-module__product_selected_content__YS'));
    const short = gidShort(gid);
    const want = normalize(name || '');
    // 1) Prefer an explicit data-product-gid match
    if (short) {
      const byAttr = items.find(it => (it.getAttribute('data-product-gid') || '') === short);
      if (byAttr) return byAttr;
    }
    // 2) Exact normalized title match
    if (want) {
      const exact = items.find(it => normalize(it.querySelector('.productSelected-module__name_product_selected__Ah span')?.textContent || '') === want);
      if (exact) return exact;
    }
    // 3) Contains normalized title
    if (want) {
      const contains = items.find(it => (normalize(it.querySelector('.productSelected-module__name_product_selected__Ah span')?.textContent || '')).includes(want));
      if (contains) return contains;
    }
    // 4) Any attribute containing the short gid (id/data/href/outerHTML fallback)
    if (short) {
      for (const it of items) {
        const idAttr = it.querySelector('[id]')?.id || '';
        const d1 = it.querySelector('[data-product-gid]')?.getAttribute('data-product-gid') || '';
        const d2 = it.getAttribute('data-product-gid') || '';
        const html = it.outerHTML || '';
        if (idAttr.includes(short) || d1.includes(short) || d2.includes(short) || html.includes(short)) return it;
      }
    }
    return null;
  }

  async function waitForFooter(gid, name, timeout = 5000, poll = 150) {
    const end = Date.now() + timeout;
    while (Date.now() < end) {
      const node = findFooter(gid, name);
      if (node) {
        await new Promise(r => setTimeout(r, 120));
        const qtyEl = node.querySelector('.quantityInput-module__product_quantity__bZ');
        const qty = readQty(qtyEl);
        if (!isNaN(qty)) return { node, qtyEl, qty };
      }
      await new Promise(r => setTimeout(r, poll));
    }
    return null;
  }

  async function reconcile(footerNode, targetQty) {
    if (!footerNode) return;
    const qtyEl = footerNode.querySelector('.quantityInput-module__product_quantity__bZ');
    let cur = readQty(qtyEl);
    const delta = targetQty - cur;
    if (delta === 0) return;
    const plus = footerNode.querySelector('.quantityInput-module__icon_product_quantity__Xv:last-child');
    const minus = footerNode.querySelector('.quantityInput-module__icon_product_quantity__Xv:first-child');
    if (delta > 0 && plus) {
      for (let i=0;i<delta;i++){ userClick(plus); await new Promise(r=>setTimeout(r,100)); }
    } else if (delta < 0 && minus) {
      for (let i=0;i<Math.abs(delta);i++){ userClick(minus); await new Promise(r=>setTimeout(r,100)); }
    }
    if (typeof updateFooterItemCount === 'function') updateFooterItemCount();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.QUICK_VIEW_ADD_TO_BOX_BUTTON_TS, .addToBoxButton-module__button_atc__zo button, .modalDetailProduct-module__product_modal_btn_atc__Si');
    if (!btn) return;
    const modal = btn.closest('.modalDetailProduct-module__product_content_action__fJ, .modalDetailProduct-module__product_modal_quantity__Wa');
    if (!modal) return;

    // Capture identifiers immediately
    const qtyInput = modal.querySelector('input[name="quantity"]');
    const gid = qtyInput?.id || modal.querySelector('[data-product-gid]')?.getAttribute('data-product-gid') || null;
    const nameHint = gid ? titleFromMin2ByGid(gid) : null; // Use Shopify title from min-2 list

    // Capture pre-add footer qty synchronously (before Easify updates)
    const preNode = findFooter(gid, nameHint);
    const preQty = preNode ? (readQty(preNode.querySelector('.quantityInput-module__product_quantity__bZ')) || 0) : 0;

    // Let Easify run, then compute addQty and reconcile
    setTimeout(async () => {
      // Quantity to add (delta)
      let addQty = 1;
      if (qtyInput) {
        const settleEnd = Date.now() + 600;
        while (Date.now() < settleEnd) {
          const v = parseInt(qtyInput.value||'0',10);
          if (!isNaN(v) && v >= 1) { addQty = v; break; }
          await new Promise(r => setTimeout(r,40));
        }
      }

      // Enforce min-2 delta by product ID
      if (gid && typeof isMin2ByGid === 'function' && isMin2ByGid(gid)) {
        addQty = Math.max(2, addQty);
      }

      // Wait for footer to reflect Easify's add
      await new Promise(r=>setTimeout(r, 10));
      const found = await waitForFooter(gid, nameHint, 500, 150);
      if (!found) return;
      const { node: footerNode, qty: postQty } = found;

      // Target final = preQty + addQty
      const expectedFinal = preQty + addQty;
      if (postQty !== expectedFinal) {
        await reconcile(footerNode, expectedFinal);
      }

      if (typeof updateFooterItemCount === 'function') updateFooterItemCount();
    }, 90);
  }, true);
})();